import React, { Fragment, useState } from "react";
import { useSortBy } from "react-instantsearch";
import Accordion from "../../UI/Accordion/Accordion";
import classes from "./CustomSort.module.scss";

const CustomSort = (props) => {
    // eslint-disable-next-line
    const [categoryValue, setCategoryValue] = useState("");

    const { currentRefinement, refine } = useSortBy(props);
    const handleChange = (event) => {
        setCategoryValue(event.target.querySelector("input").value);
        refine(event.target.querySelector("input").value);
        event.target.querySelector("input").checked = true;
    };

    return (
        <div className={classes["custom-sort"]}>
            <div className={classes["custom-sort__radio"]}>
                <Accordion additionalClass={true} header="Sortieren nach">
                    {props.items.map((item, index) => (
                        <label
                            htmlFor={item.value}
                            key={index}
                            onClick={handleChange}
                        >
                            <Fragment key={index}>
                                <input
                                    key={index}
                                    type="radio"
                                    value={item.value}
                                    name="sort"
                                    defaultChecked={
                                        item.value === currentRefinement
                                    }
                                />

                                {item.label}
                            </Fragment>
                        </label>
                    ))}
                </Accordion>
            </div>
        </div>
    );
};

export default CustomSort;
